import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DealerGroupsState } from '../../interfaces/dealer-group.interface';
import { map, scan, shareReplay, tap } from 'rxjs/operators';
import { DealerGroupAction, reducer, Selector, SetState, ToggleAll, ToggleGroup, ToggleMember } from '../lead-seller-group/reducer';

@Injectable({
  providedIn: 'root'
})
export class LeadSellerPreferencesService {
  private static initialState: DealerGroupsState = {
    memberEntities: {},
    memberUuids: [],
    groupEntities: {},
    groupUuids: []
  };

  private searchTerm = new BehaviorSubject<string>('');

  actions = new BehaviorSubject<DealerGroupAction>(new SetState(LeadSellerPreferencesService.initialState));

  /**
   * Every time a new response is received, the response is mapped to the expected state.
   * Every time an action is received, it is applied to the current state. If a new response is received the state is reset.
   */
  readonly state$: Observable<DealerGroupsState> = this.actions.asObservable().pipe(
    scan(reducer, undefined),
    tap((state: DealerGroupsState) => this.currentState.next(state)),
    shareReplay(1)
  );

  private currentState = new BehaviorSubject<DealerGroupsState>(undefined);


  constructor() { }

  snapShot() {
    return this.currentState.getValue();
  }

  setState(state: DealerGroupsState) {
    this.actions.next(new SetState(state));
  }

  search(searchTerm: string) {
    this.searchTerm.next(searchTerm);
  }

  toggleGroup(uuid: string) {
    this.actions.next(new ToggleGroup(uuid));
  }

  toggleAll() {
    this.actions.next(new ToggleAll());
  }

  toggleMember(uuid: string) {
    this.actions.next(new ToggleMember(uuid));
  }

  select<T>(selectFn: Selector<T>): Observable<T> {
    return this.state$.pipe(map(selectFn));
  }

}
